'use strict';

var util = require('../util'),
	login = require('../login'),
	dialog = require('../dialog'),
	giftguru = require('./giftguru.js'),
	inventingroom = require('./inventingroom'),
	registration = require('../registration'),
	linchpinError = require('int_googletagmanager/linchpin/error');

/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */
function toggleFullOrder () {
	$('.order-items')
		.find('li.hidden:first')
		.prev('li')
		.append('<a class="toggle">View All</a>')
		.children('.toggle')
		.click(function () {
			$(this).parent().siblings('li.hidden').show();
			$(this).remove();
		});
}

/**
 * @private
 * @function
 * @description Initializes Tasting Club content asset welcome carousel
 */
function initTcWelcome() {
	var url = util.appendParamsToUrl(Urls.tcWelcome);
	dialog.open({
		url: url,
		options: {
			dialogClass: 'tcWelcome-dialog',
			open: function () {
				$('.content-asset-carousel').slick({infinite: false, dots: true, dotsClass: 'slick-dots', slide: 'div'});
				// slider controls to close popup
				$('.tcWelcome-dialog button').on('click', function () {
					if ($(this).hasClass('slick-disabled')) {
						$('button.slick-disabled').on('click', function () {
							dialog.close();
						});
					}
				});
			}
		}
	});
}

/**
 * @private
 * @function
 * @description Binds the events for the my details page
 */
function initProfileUpdate() {
	$('select[name$="_stores"]').on('change', function () {
		$('input[name$="_preferredStoreID"]').val($('select[name$="_stores"]').val());
	});

	$(document).ready(function () {
		$('select[name$="_day"]').val($('#birth-day').val()).change();
		$('select[name$="_month"]').val($('#birth-month').val()).change();
		$('select[name$="_year"]').val($('#birth-year').val()).change();
	});

	// Make current password field required when email(login) changes
	$('input[name$="_mydetails_profile_email"]').on('change', function () {
		var currentLogin = $('input[name=currentLogin]').val();
		if ($(this).val() !== currentLogin) {
			$('input[name$=_password_current]').addClass('required');
		} else {
			if ($('input[name$=_password_current]').hasClass('required')) {
				$('input[name$=_password_current]').removeClass('required error');
				$('input[name$=_password_current]').closest('.form-row ').find('.error-msg').remove();
			}
		}
	});

	// If one of new password fields is not empty - make all password fields required
	$('input[name$=_password_new]').on('change', function () {
		if ($(this).val() !== '') {
			$('input[name$=_password_current]').addClass('required');
			$('input[name$=_password_newconfirm]').addClass('required');
		} else {
			if ($('input[name$=_password_current]').hasClass('required')) {
				$('input[name$=_password_current]').removeClass('required');
			}
			if ($('input[name$=_password_newconfirm]').hasClass('required')) {
				$('input[name$=_password_newconfirm]').removeClass('required');
			}
		}
	});
	$('input[name$=_password_newconfirm]').on('change', function () {
		if ($(this).val() !== '') {
			$('input[name$=_password_current]').addClass('required');
			$('input[name$=_password_new]').addClass('required');
		} else {
			if ($('input[name$=_password_current]').hasClass('required')) {
				$('input[name$=_password_current]').removeClass('required');
			}
			if ($('input[name$=_password_new]').hasClass('required')) {
				$('input[name$=_password_new]').removeClass('required');
			}
		}
	});

	// GTM Linchpin analytics
	if (SitePreferences.GTM_ENABLED) {
		$('.form-row.error input').each(function () {
			linchpinError.pushErrorfield($(this));
		});
		linchpinError.pushFormFieldsErrorList();

		$('[id$=MyDetailsForm]').on('change', '.form-row input', function () {
			linchpinError.pushSingleErrorObject($(this));
		});
		$('[id$=MyDetailsForm]').on('submit', function () {
			$('.form-row input.error').each(function () {
				linchpinError.pushErrorfield($(this));
			});
			linchpinError.pushFormFieldsErrorList();
			if (!birthdayIsValid()) {
				var dateErrorOffset = $('.date-wrapper.error').offset().top;
				window.scrollTo({
					top: dateErrorOffset,
					behavior: 'smooth'
				});
				return false;
			}
		});
	}
}

// process chosen birthday, if the user is younger that 18, show restriction note
function birthdayIsValid() {
	var $myDetailsForm = $('form#MyDetailsForm');
	var $birthdayWrapper = $myDetailsForm.find(".date-wrapper");
	if ($birthdayWrapper.length) {
		var dayValue = $birthdayWrapper.find('select[name$="_day"]').val();
		var monthValue = $birthdayWrapper.find('select[name$="_month"]').val() - 1;
		var yearValue = $birthdayWrapper.find('select[name$="_year"]').val();
		var currentDate = new Date();
		var adultAgeDate = new Date(yearValue, monthValue, dayValue);
		adultAgeDate.setFullYear(adultAgeDate.getFullYear() + 18);

		if (currentDate < adultAgeDate) {
			$('.age-restriction-note').addClass('active');
			$birthdayWrapper.addClass('error');
			return false;
		}
		$('.age-restriction-note').removeClass('active');
		$birthdayWrapper.removeClass('error');
		return true;
	}
	return true;
}

/**
 * @private
 * @function
 * @description Enables submit button on MyDetailsForm
 */
function initSavedBtnValidation() {
	$('.pwd-saved-btn button').attr('disabled', true);

	$(document).ready(function () {
		$('#MyDetailsForm :input').change(function () {
			$(this).data('changed', true);
			if ($(this).data('changed')) {
				$('.pwd-saved-btn button').attr('disabled', false);
			}
		});
	});
}
function accountMedalsRepositioning () {
	var medals = $('.account-medals').detach(),
		heading = $('#page_heading');

	if (util.viewport.isStandard()) {
		medals.appendTo(heading);
		heading.addClass('medals');
	} else {
		medals.appendTo('.account-medals-wrp');
		heading.removeClass('medals');
	}

}
function accountMedalsInit () {
	// assign event handlers to medal icons
	$('.account-medals .medal').on('touchstart click mouseenter', function () {
		$('#accountMedalMessage').html($(this).find('.medal_content').html());
	});

	//re-locate based on the viewport
	if ($('.account-medals').length === 1) {
		accountMedalsRepositioning();
		$(window).smartresize(accountMedalsRepositioning);
	}


}
function initVipmeJoin () {
	$('.js-account-vipme-slot a, .account-landing-slot a').on('click', function (e) {
		e.preventDefault();
		var url = util.appendParamsToUrl(this.href, {
			src: 'account'
		});
		window.location.href = url;
	});
}

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents () {
	toggleFullOrder();
	initProfileUpdate();
	login.init();
	initSavedBtnValidation();
	inventingroom.init();
	accountMedalsInit();
	initVipmeJoin();

	// Display TC Welcome pop-up if this element exists
	if ($('#tasting-club-welcome').length > 0) {
		initTcWelcome();
	}

	if ($('.search-load-in-primary').length > 0) {
		require('./search').init();
	}

	if ($('#RegistrationForm').length > 0) {
		registration.init();
	}
}

var account = {

	init: function () {
		initializeEvents();
		giftguru.init();
	},

	initCartLogin: function () {
		login.init();
	}
};

module.exports = account;
